<template>
  <situation-centre-component />
</template>

<script>
import SituationCentreComponent from "@/components/situation-center/situation-center";

export default {
  components: {
    SituationCentreComponent
  }
};
</script>

<style></style>
